import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { ClaudeIcon } from '@atlassian/logo-third-party/claude';
import { CursorIcon } from '@atlassian/logo-third-party/cursor';

import { RovoTileIcon } from './RovoTileIcon.tsx';

const styles = cssMap({
	pile: {
		display: 'inline-flex',
		alignItems: 'center',
		flexShrink: 0,
	},
	claude: {
		rotate: '-6deg',
	},
	tile: {
		display: 'inline-flex',
		marginInlineStart: token('space.negative.050'),
	},
});

export function ShareContextAgentIcons(): React.JSX.Element {
	return (
		<Box as="span" aria-hidden="true" xcss={styles.pile}>
			<RovoTileIcon size="xxsmall" />
			<Box as="span" xcss={cx(styles.tile, styles.claude)}>
				<ClaudeIcon label="" size="xxsmall" />
			</Box>
			<Box as="span" xcss={styles.tile}>
				<CursorIcon label="" size="xxsmall" />
			</Box>
		</Box>
	);
}
